import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {AgentVirtualContactSquadQrContainerModel} from "../../../../../../../models/aggregates/alg/cc/link";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class AgentVirtualContactSquadQrService extends BaseApiTemplateService<AgentVirtualContactSquadQrContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agent-vc-squad-qr-codes';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agent-vc-squad-qr-codes';
    this.httpClient = http;
  }
}
